import { ShirtspaceResponse } from "@services/shirtspace.types";
import { ProductAvailability } from "~/entities/product/types";

export const fetchProductAvailability = async (
  styleCode: string,
  color: string,
): Promise<ShirtspaceResponse<ProductAvailability>> => {
  const searchParams = new URLSearchParams({
    style_code: styleCode,
    color,
  }).toString();

  try {
    const request = await fetch(
      `/resources/product-availability?${searchParams}`,
    );

    if (!request.ok) throw new Error("Failed to fetch product availability");

    const response =
      (await request.json()) as ShirtspaceResponse<ProductAvailability>;

    return response;
  } catch (error) {
    return {
      data: undefined,
      messages: [
        {
          type: "error",
          text: "An unknown error occurred while making this request",
        },
      ],
    };
  }
};
